export default __webpack_public_path__ + "static/media/60497166-F890-4930-8F04-20C21DC832F9.20075501.jpg";